import { Box } from '@mui/material';
import GreivanceRedressalDesktop from './GreivanceRedressalComponent';

export default function GreivanceRedressal() {
  return (
    <Box mt={['2.75rem', '2.75rem', '5.5625rem']}>
      <GreivanceRedressalDesktop />
    </Box>
  );
}
